// extracted by mini-css-extract-plugin
export default {"container":"PartnerDeals_container__caK2L"};